import { feedbackcard } from '~/components/FeedbackCard'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18n-lite'

const AUTO_CLOSE_TOAST_TIME = 5000

export type DisplayUserErrorProps = {
  title?: string
  error?: unknown
  userMessageFallback?: string
  autoClose?: number
}

export default function useDisplayUserError() {
  const { t } = useTranslation()

  const displayUserError = useCallback(
    ({
      title,
      error,
      userMessageFallback,
      autoClose = AUTO_CLOSE_TOAST_TIME
    }: DisplayUserErrorProps) => {
      const finalTitle = title || t('system.error.title')

      const errorMessage =
        error instanceof Object &&
        'message' in error &&
        typeof error.message === 'string'
          ? error.message
          : ''

      const userErrorMessage = errorMessage.includes('<user-error>')
        ? errorMessage.replace(/.*<user-error>(.*)<\/user-error>.*/, '$1')
        : ''

      const message =
        userErrorMessage || userMessageFallback || t('system.error.message')

      feedbackcard(finalTitle, {
        message,
        autoClose,
        type: 'error'
      })
    },
    [t]
  )

  return { displayUserError }
}
